const MAILBOX_T = {

    form_name: "Nombre",
    form_email: "Correo Electrónico (opcional)",
    form_number: "Celular (opcional)",
    form_subject: "Asunto",
    form_message: "Mensaje",
    form_btn: "Enviar",
    title: "Contacte con nosotros",
    subTitle_1: "Forma Presencial",
    subTitle_5: "Horario de atencion",
    text_11: "Calle 36 # 31-39 Local 101, Bucaramanga, Santander",
    text_12: "Centro Empresarial Chicamocha",
    text_13: "Lunes a Viernes: 07:30 a.m - 12:30 p.m y 1:30 p.m - 4:30 p.m",
    text_14: "Bucaramanga, Santander",
    subTitle_2: "A Distancia",
    text_21: "Cel: (+57) 316 279 5010",
    text_22: "Tel: (607) 680 3596",
    text_23: "curaduriaurbana1@gmail.com",
    text_24: "Chat de Whatsapp en Línea",
    subTitle_3: "Localización de la Curaduría Urbana N°1 de Bucaramanga",
    subTitle_4: "Forma Virtual",
    text_41: "Formulario de contacto directo con la Curaduría Urbana N°1 de Bucaramanga",
}

export default MAILBOX_T;